import React, { useState, useEffect } from "react";
import MUITable from "Components/UI/Tables/MUITable";

import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import cutStrAtAndAddDots from "utils/cutStrAtAndAddDots";
import { price2StringPrice } from "utils/priceformatter";
import Box from "@mui/material/Box";
import usePost from "Hooks/usePost";
import { updateInvoiceFfdate } from "API/swesum";
import { useNavigate } from "react-router-dom";
import useTableOptions from "Hooks/useTableOptions";
import {
  getParseStatusLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import CommonChip from "Components/UI/Tables/CommonChip";

import RefreshBtn from "Components/UI/Tables/RefreshBtn";
import ToggleSelectBtn from "Components/UI/Tables/ToggeSelectBtn";
import { useInvoices } from "Context/Invoices";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const createTableRows = (invoices) => {
  return invoices.map((i) => {
    return [
      i.Id,
      i.Title,

      i.EndCustomerId,
      i.EndCustomerName,

      i.ClientId,
      i.ClientName,

      price2StringPrice(i.Price === null ? 0 : i.Price),
      i.FileId,
      i.OCR,
      i.CalcFfdDate ?? i.OriginalFfdDate,
      getParseStatusLabelById(i.ParseStatus),
      cutStrAtAndAddDots(i.ParseMessage, 45),
      getSystemStatusLabelById(i.SystemStatus),
      i.CreateTime,
    ];
  });
};

const initialState = {
  ArrOfInvoices: "",
  NewFfd: "",
};

export default function InvoicesTable() {
  const { fetchAllInvoices, invoices } = useInvoices();
  const { handleColumnShow, isColDisplayed } =
    useTableOptions("InvoicesMainTable");
  const [disableCheckboxes, setDisableCheckboxes] = useState(true);
  const [rows, setRows] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [formMessage, setFormMessage] = useState("Status");
  const navigate = useNavigate();
  const { openError } = usePopupNotificationContext();

  useEffect(() => {
    fetchAllInvoices();
  }, []);

  useEffect(() => {
    setRows(createTableRows(invoices));
  }, [invoices]);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
        display: isColDisplayed("ID"),
      },
    },
    {
      name: "Titel",
      options: {
        filter: false,
        display: isColDisplayed("Titel"),
      },
    },
    {
      name: "Slutkunds ID",
      options: {
        filter: true,
        display: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/endcustomers/${rows[dataIndex][2]}`}>
              {rows[dataIndex][2]}
            </Link>
          );
        },
      },
    },
    {
      name: "Slutkund",
      options: {
        filter: true,
        display: isColDisplayed("Slutkunds Titel"),
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/endcustomers/${rows[dataIndex][2]}`}>
              {rows[dataIndex][3]}
            </Link>
          );
        },
      },
    },
    {
      name: "Klient ID",
      options: {
        filter: true,
        display: isColDisplayed(false),
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/clients/${rows[dataIndex][4]}`}>
              {rows[dataIndex][4]}
            </Link>
          );
        },
      },
    },
    {
      name: "Klient",
      options: {
        filter: true,
        display: isColDisplayed("Klient Titel"),
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/clients/${rows[dataIndex][4]}`}>
              {rows[dataIndex][5]}
            </Link>
          );
        },
      },
    },
    {
      name: "Belopp",
      options: {
        filter: false,
        display: isColDisplayed("Belopp"),
      },
    },
    {
      name: "Fil ID",
      options: {
        filter: true,
        display: isColDisplayed("Fil ID"),
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/files/${rows[dataIndex][7]}`}>
              {rows[dataIndex][7]}
            </Link>
          );
        },
      },
    },
    {
      name: "OCR",
      options: {
        filter: false,
        display: isColDisplayed("OCR"),
      },
    },
    {
      name: "FFD",
      options: {
        filter: false,
        display: isColDisplayed("FFD"),
      },
    },
    {
      name: "Kontrollstatus",
      options: {
        filter: true,
        display: isColDisplayed("Kontrollstatus"),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Kontrollmeddelande",
      options: {
        filter: false,
        display: isColDisplayed("Kontrollmeddelande"),
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        display: isColDisplayed("Status"),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "CreateTime",
      label: "Skapad",
      options: {
        filter: false,
        display: isColDisplayed("CreateTime"),
      },
    },
  ];

  const handleRowSelection = (
    currentRowsSelected,
    allRowsSelected,
    rowsSelected
  ) => {
    setSelectedRows([...rowsSelected]);
  };
  const options = {
    // filterType: "checkbox",
    onViewColumnsChange: (changedColumn, action) => {
      handleColumnShow(changedColumn, action);
    },
    customToolbar: () => {
      return (
        <>
          <ToggleSelectBtn
            onClick={() => setDisableCheckboxes(!disableCheckboxes)}
          />
          <RefreshBtn />
        </>
      );
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => handleRowSelection(currentRowsSelected, allRowsSelected, rowsSelected),
    rowsSelected: selectedRows,
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: disableCheckboxes,
    downloadOptions: {
      separator: ";",
      filename: "all_clients.csv",
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };
  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const updateInvoiceFfdateReq = usePost({
    mtnFunc: (body) => updateInvoiceFfdate(body),
    onError: () => {
      openError("Ett fel har uppstått", 3000);
    },
    onSuccess: (body) => {
      setFormMessage(body.Message);
      navigate(`/invoices`);
    },
  });

  const handleOnClick = () => {
    updateInvoiceFfdateReq.post(formData);
  };

  useEffect(() => {
    if (selectedRows.length != 0) {
      setFormData({
        ...formData,
        ArrOfInvoices: selectedRows.map((x) => rows[x][0]),
      });
    }
  }, [selectedRows, formData, rows]);

  return (
    <MUITable
      components={{
        TableToolbarSelect: (props) => {
          return (
            <Box
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                minHeight: "64px",
              }}
            ></Box>
          );
        },
      }}
      options={options}
      title={""}
      data={rows}
      columns={columns}
    ></MUITable>
  );
}
